export const getCountContent = (
    count: number | null | undefined,
    singularLabel: string
) => `${count} ${count === 1 ? singularLabel : `${singularLabel}s`}`;
